import _ from 'lodash'

export default {
  setServiceCategories(state, value) {
    state.serviceCategories = value
  },
  updateServiceCategory(state, payload) {
    const serviceCategoryID = payload.id
    const key = payload.key
    const value = payload.value

    const serviceCategory = _.find(state.serviceCategories, serviceCategory => {
      if (serviceCategory.id == serviceCategoryID) {
        return true
      }
      return false
    })

    if (serviceCategory !== undefined) {
      serviceCategory[key] = value
    }
  },
  appendServiceCategoryServices(state, payload) {
    const serviceCategoryID = payload.id
    const services = payload.services

    const serviceCategory = _.find(state.serviceCategories, serviceCategory => {
      if (serviceCategory.id == serviceCategoryID) {
        return true
      }
      return false
    })

    if (serviceCategory !== undefined) {
      serviceCategory.services = serviceCategory.services.concat(services)
    }
  },
  setServiceCategoryServices(state, payload) {
    const serviceCategoryID = payload.id
    const services = payload.services

    const serviceCategory = _.find(state.serviceCategories, serviceCategory => {
      if (serviceCategory.id == serviceCategoryID) {
        return true
      }
      return false
    })

    if (serviceCategory !== undefined) {
      serviceCategory.services = services
    }
  },
  selectService(state, service) {
    if (state.activeServicesMap[service.id]) {
      delete state.activeServicesMap[service.id]
    } else {
      state.activeServicesMap[service.id] = service
    }

    state.activeServicesMap = _.cloneDeep(state.activeServicesMap)
  },
  setActiveServicesMap(state, servicesMap) {
    state.activeServicesMap = servicesMap
  },
  setSwitchedCategory(state, categoryId) {
    state.switchedCategoryId = categoryId
  },
}
